import { MapSearchService } from '@modules/hotel-booking/services/map-search/map-search.service';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { IProperty } from '@modules/hotel-booking/models/hotel-search.model';
import { environment } from '@env/environment';
import { SearchService } from '@modules/hotel-booking/services/search/search.service';
import { ActivatedRoute } from '@angular/router';
import { PlaceType } from '@shared/enum/recommend-place.enum';

@Component({
  selector: 'app-list-of-hotel-on-map',
  templateUrl: './hotel-result-card-on-map.component.html',
  styleUrls: ['./hotel-result-card-on-map.component.scss']
})
export class HotelResultCardOnMap implements AfterViewInit {
  @Input() item: IProperty | any;
  @Input() isLoading: boolean;
  @Input() isLoadingAPI: boolean;
  @Output("openPopup") openPopup: EventEmitter<any> = new EventEmitter();
  @ViewChild('selectedCardRef', { static: false }) selectedCardRef!: ElementRef;
  @ViewChild('propertyName', { static: false }) propertyName!: ElementRef<HTMLElement>;
  isDisplayToolTip: boolean = false;

  isToggle: boolean = true;
  isFavorite: boolean = false;
  baseUrl = environment.BASE_PATH;
  baseImageId = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
  isLoadingPriceCache: boolean = true;
  placeAdress: string;

  constructor(
    private mapSearchService: MapSearchService,
    private cd: ChangeDetectorRef,
    private searchService: SearchService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(){
    this.route.queryParams.subscribe((params: any) => {
      const cityName = params['city_name'] || '';
      const destType = params['dest_type'] || '';
      if(cityName && destType == PlaceType.PLACES.toUpperCase()){
        this.placeAdress = cityName;
      } else {
        this.placeAdress = '';
      }
    });
  }

  ngAfterViewInit(): void {
    this.isEllipsisActive();
    this.searchService.isLoadingPrice().subscribe(isLoading => this.isLoadingPriceCache = isLoading);
    this.cd.detectChanges();
  }

  isEllipsisActive() {
    if (this.propertyName) {
      const { scrollWidth, clientWidth } = this.propertyName.nativeElement;
      this.isDisplayToolTip = scrollWidth > clientWidth;
    }
  }

  public handleFavorite(event: Event) {
    event.stopPropagation();
    this.isFavorite = !this.isFavorite;
  }

  public renderStar(number: number): any {
    return [...Array(number)];
  }

  childClick(event: Event) {
    this.deselectAll();
    this.mapSearchService.setMarker(this.item)
    this.selectedCardRef.nativeElement.classList.add('selected-card')
    this.openPopup.emit()
  }

  deselectAll() {
    document.querySelectorAll('[id^="map-"]').forEach(element => {
      element.classList.remove('selected-card');
    }
    );
  }

  replaceWithDefaultImage(event: any): void {
    event.target.src = 'assets/images/temporary/default-hotel.png';
  }
}
